import { horas, type Ocupacao } from "./formato";

/** Quem mais usa cada cadeira: horas agendadas por profissional em cada sala. */
export function UsoPorProfissional({ ocupacao }: { ocupacao: Ocupacao }) {
  const nome = (id: string) => ocupacao.salas.find((s) => s.salaId === id);
  const linhas = ocupacao.porProfissional.filter((x) => x.min > 0);
  return (
    <section className="rounded-xl border border-zinc-200 bg-white p-4 shadow-sm dark:border-border dark:bg-card">
      <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Por profissional</h3>
      <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">Horas agendadas de cada profissional em cada sala.</p>
      {linhas.length ? (
        <div className="mt-3 max-h-72 overflow-auto rounded-lg border border-zinc-100 dark:border-border">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-zinc-50 text-[10px] uppercase tracking-wider text-zinc-500 dark:bg-muted dark:text-muted-foreground">
              <tr>
                <th className="px-3 py-2 text-left font-semibold">Profissional</th>
                <th className="px-3 py-2 text-left font-semibold">Sala</th>
                <th className="px-3 py-2 text-right font-semibold">Horas</th>
              </tr>
            </thead>
            <tbody>
              {linhas.map((l) => {
                const s = nome(l.salaId);
                return (
                  <tr key={`${l.salaId}|${l.profissional}`} className="border-t border-zinc-100 dark:border-border/50">
                    <td className="px-3 py-1.5 text-zinc-800 dark:text-foreground">{l.profissional ?? "Sem profissional"}</td>
                    <td className="px-3 py-1.5 text-zinc-600 dark:text-muted-foreground">
                      <span className="inline-flex items-center gap-1.5">
                        <span className="h-2 w-2 rounded-full" style={{ backgroundColor: s?.cor ?? "#a1a1aa" }} />
                        {s?.nome ?? "Sala"}
                      </span>
                    </td>
                    <td className="px-3 py-1.5 text-right tabular-nums text-zinc-800 dark:text-foreground">{horas(l.min)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="py-8 text-center text-sm text-zinc-500 dark:text-muted-foreground">Nenhuma consulta com sala neste mês.</p>
      )}
    </section>
  );
}
